import { IconLineLive } from "@kalodata/kds-design-icons";
import { TestId } from "@shared/testIds";
import { Trans } from "react-i18next";
import { twMerge } from "tailwind-merge";
import type { PostVideoSourceTab } from "./constants";
import { IconFolder } from "@icons/index";

const sourceTabTestId: Record<PostVideoSourceTab, TestId> = {
  library: TestId.PostVideoSourceTabLibrary,
  videoFile: TestId.PostVideoSourceTabVideoFile,
};

export interface PostVideoSourceTabsProps {
  value: PostVideoSourceTab;
  onChange: (value: PostVideoSourceTab) => void;
}

const tabs: { value: PostVideoSourceTab; label: React.ReactNode; icon: React.ReactNode }[] = [
  {
    value: "library",
    label: <Trans>Library</Trans>,
    icon: <IconFolder className="w-[20px] h-[20px] shrink-0 text-black" />,
  },
  {
    value: "videoFile",
    label: <Trans>Upload</Trans>,
    icon: <IconLineLive size={20} className="shrink-0" />,
  },
];

export const PostVideoSourceTabs = ({ value, onChange }: PostVideoSourceTabsProps) => {
  return (
    <div className="flex h-[56px] items-center border-b border-kds-border px-[16px]">
      <div className="flex items-center gap-[8px]">
        {tabs.map((tab) => {
          const isActive = tab.value === value;
          return (
            <button
              key={tab.value}
              type="button"
              data-testid={sourceTabTestId[tab.value]}
              onClick={() => onChange(tab.value)}
              className={twMerge(
                "flex items-center justify-center py-[12px]",
                isActive && "border-b-2 border-kds-dark-reverse",
              )}
            >
              <span
                className={twMerge(
                  "flex h-[32px] items-center justify-center gap-[6px] rounded-[8px] px-[12px] py-[6px] text-[14px] font-medium leading-[16px] cursor-pointer hover:bg-kds-bg-overlay",
                  isActive ? "border border-kds-border-solid text-kds-fg" : "text-kds-fg-soft",
                )}
              >
                {tab.icon}
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
